import React from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";

export default function TermsAndConditions() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#130828] flex flex-col items-center py-8 px-4">
      <div className="flex items-center text-center w-full max-w-md relative mb-8">
        <button
          className="mb-8"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <BsArrowLeft width={20} height={20} color="#fff" />
        </button>
        <h2 className="text-white mx-auto text-2xl font-bold mb-8">
          Terms & Condition
        </h2>
      </div>
      <h2 className="text-white text-2xl font-bold mb-6 text-center">
        SKYBOARD GAMES LIMITED
      </h2>
      <div className="w-full max-w-2xl bg-[#1E1B2E] rounded-2xl p-6 shadow-lg overflow-y-auto max-h-[80vh]">
        <h3 className="text-[#6499FF] text-lg font-semibold mb-2 text-center">
          User Agreement / Terms and Conditions
        </h3>
        <div className="text-gray-300 text-xs mb-4 text-center">
          Last Updated: 1st July, 2025
        </div>
        <div className="text-gray-200 text-sm space-y-4">
          <div>
            <b>1. Introduction</b>
            <br />
            Welcome to Skyboard Games Limited (“Skyboard Games,” “we,” “us,” or “our”). These Terms and Conditions (the “Agreement”) govern your use of our website, mobile application, and other services (collectively, the “Platform”) offered by Skyboard Games.
            <br />
            By accessing or using our Platform, you agree to be bound by these Terms. If you do not agree, you must not use our Platform.
          </div>
          <div>
            <b>2. Eligibility</b>
            <br />
            2.1. You must be at least 18 years old to use this Platform.
            <br />
            2.2. You represent and warrant that all registration information you submit is accurate and truthful.
            <br />
            2.3. You have the legal capacity to enter into a binding agreement.
            <br />
            2.4. Access to our services is not permitted where prohibited by law. It is your responsibility to ensure you comply with applicable laws.
          </div>
          <div>
            <b>3. Services Offered</b>
            <br />
            Skyboard Games offers real-time interactive gaming services, where users can play with in-app tokens on games of chance and/or skill hosted digitally on the Platform...
          </div>
          <div>
            <b>4. Account Registration</b>
            <br />
            4.1. To access interactive gaming services, you must create an account.
            <br />
            4.2. You agree to maintain the confidentiality of your login credentials and accept responsibility for all activities under your account.
            <br />
            4.3. Skyboard Games shall not be liable for unauthorized access due to your failure to secure your account.
            <br />
            4.4. You must promptly notify Skyboard Games of any unauthorized use of your account.
            <br />
            4.5. We reserve the right to suspend or terminate accounts for suspicious, fraudulent, or unlawful activity.
          </div>
          <div>
            <b>5. Use of the Platform</b>
            <br />
            5.1. You may only use the Platform for lawful interactive gaming activities.
            <br />
            5.2. You must not interfere with the operation of the Platform or engage in fraudulent or manipulative behaviour.
            <br />
            5.3. Automated bots or scripts are strictly prohibited.
          </div>
          <div>
            <b>6. Game Rules & Playing Conditions</b>
            <br />
            6.1. Each interactive game has its own rules, mechanics, and scores which are published on the Platform.
            <br />
            6.2. Once initiated and accepted, plays using in-app tokens cannot be cancelled or amended by you.
            <br />
            6.3. Users are responsible for understanding the applicable game rules before participating.
            <br />
            6.4. Skyboard Games reserves the right to cancel or void a game session...
          </div>
          <div>
            <b>7. Responsible Gaming</b>
            <br />
            7.1. Skyboard Games supports responsible gaming and provides features such as:
            <br />
            a) Self-exclusion options
            <br />
            b) Play limits using in-app tokens
            <br />
            c) Access to third-party support for addiction-related issues
          </div>
          <div>
            <b>8. Token Winnings and Withdrawals</b>
            <br />
            8.1. Users may earn in-app tokens through gameplay and may request to convert eligible token winnings into redeemable value, as determined by the Platform.
            <br />
            8.2. Withdrawal of token winnings is subject to verification, compliance checks, and platform-specific conditions.
            <br />
            8.3. Skyboard Games may request identity confirmation or additional information before approving any withdrawal request, to ensure legal and system integrity.
            <br />
            8.4. Tokens that are awarded as bonuses, promotions, or not classified as winnings may not be eligible for withdrawal or conversion.
            <br />
            8.5. The Platform may offer users approved methods to inject additional in-app tokens, such as through designated exchange channels, reward systems, or other mechanisms made available from time to time.
            <br />
            8.6. Any attempt to abuse or manipulate the token injection or withdrawal systems may result in suspension or restriction of access to the Platform.
          </div>
          <div>
            <b>9. Bonuses and Promotions</b>
            <br />
            9.1. Promotions are subject to specific terms, including wagering requirements.
            <br />
            9.2. Skyboard Games reserves the right to cancel or amend any promotion at its discretion.
          </div>
          <div>
            <b>10. Intellectual Property</b>
            <br />
            10.1. All content on the Platform, including logos, game designs, software, text, and graphics, is the intellectual property of Skyboard or its licensors. Users may not reproduce, modify, or commercially exploit any content without prior written consent.
          </div>
          <div>
            <b>11. Limitation of Liability & Indemnity</b>
            <br />
            11.1. Skyboard Games provides the Platform “as is” and does not guarantee uninterrupted or error-free operation.
            <br />
            11.2. We shall not be liable for any indirect, incidental, or consequential damages, including loss of tokens or data.
            <br />
            11.3. You agree to indemnify and hold harmless Skyboard Games, its affiliates, directors, employees, and partners from any claim, liability, loss, damage, cost, or expense arising out of your use of the Platform, breach of these Terms, or violation of any applicable law.
          </div>
          <div>
            <b>12. Suspension and Termination</b>
            <br />
            12.1. We reserve the right to suspend or terminate your access to the Platform at any time for breach of these Terms or suspected illegal activity.
            <br />
            12.2. Tokens in your account at the time of closure (excluding unlawful or voided games) will be returned in accordance with our policies.
          </div>
          <div>
            <b>13. Privacy Policy</b>
            <br />
            13.1. Your use of the Platform is also governed by our Privacy Policy, which explains how we collect and use your personal data.
            <br />
            13.2. By agreeing to these Terms, you consent to our data practices.
          </div>
          <div>
            <b>14. Amendments</b>
            <br />
            14.1. We may revise these Terms at any time. Continued use of the Platform after changes are posted constitutes your acceptance.
          </div>
          <div>
            <b>15. Governing Law and Dispute Resolution</b>
            <br />
            15.1. These Terms shall be governed by the laws of the Federal Republic of Nigeria.
            <br />
            15.2. Any disputes shall be subject to the exclusive jurisdiction of the courts in Nigeria, unless otherwise required by law.
          </div>
          <div>
            <b>16. Contact Information</b>
            <br />
            For any questions or complaints, please contact:
            <br />
            Skyboard Games Limited
            <br />
            Email: skyboardgames.ng@gmail.com
          </div>
        </div>
      </div>
    </div>
  );
}
